import {
  DetalleTransporte,
  SalidaTransporte,
} from "../../../services/transporteServicios";
import { ListGroupItem } from "react-bootstrap";
import VisibilityIcon from "@mui/icons-material/Visibility";
import IconContainer from "../../organisms/IconContainer";
import SuccessIconContainer from "../../organisms/SuccessIconContainer";
import DangerIconContainer from "../../organisms/DangerIconContainer";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ClearIcon from "@mui/icons-material/Clear";
import CheckIcon from "@mui/icons-material/Check";
import { ModificacionesDetalle } from "./Modificaciones";

function SalidaItem({
  salida,
  onDetalleClick,
  onChequearSalida,
  modificacionesSalida,
  onSubirOrden,
  esPrimero,
  anterior,
  siguiente,
  onBajarOrden,
  esUltimo,
}: {
  salida: SalidaTransporte;
  onDetalleClick: (detalle: DetalleTransporte) => void;
  onChequearSalida: (salida: SalidaTransporte, transportado: boolean) => void;
  onSubirOrden: (salida: SalidaTransporte, anterior: SalidaTransporte) => void;
  onBajarOrden: (salida: SalidaTransporte, siguiente: SalidaTransporte) => void;
  modificacionesSalida: ModificacionesDetalle | undefined;
  esPrimero: boolean;
  esUltimo: boolean;
  anterior: SalidaTransporte | undefined;
  siguiente: SalidaTransporte | undefined;
}) {
  const onClickViewDetalle = () => {
    onDetalleClick(salida);
  };

  const transportado =
    modificacionesSalida && modificacionesSalida.transportado !== undefined
      ? modificacionesSalida.transportado
      : salida.transportado;

  return (
    <ListGroupItem
      as="li"
      className={`d-flex mt-2 p-1 border rounded ${
        transportado ? "border-success" : ""
      }`}
    >
      <div className="ps-2 row" style={{ paddingRight: 0 }}>
        <div className="row" style={{ paddingRight: 0 }}>
          <div className="col-7">
            <strong>{salida.mascota.nombre}</strong>
          </div>
          <div className="col-5">
            <div
              className="row justify-content-end"
              style={{ paddingRight: 0 }}
            >
              {!esPrimero && (
                <div className="col-3">
                  <IconContainer
                    onClick={() => {
                      onSubirOrden(salida, anterior!);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <ArrowUpwardIcon />
                  </IconContainer>
                </div>
              )}

              {!esUltimo && (
                <div className="col-3">
                  <IconContainer
                    onClick={() => {
                      onBajarOrden(salida, siguiente!);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <ArrowDownwardIcon />
                  </IconContainer>
                </div>
              )}
              <div className="col-3">
                <IconContainer
                  onClick={onClickViewDetalle}
                  style={{ cursor: "pointer" }}
                >
                  <VisibilityIcon />
                </IconContainer>
              </div>
              {transportado && (
                <div className="col-3">
                  <DangerIconContainer
                    onClick={() => {
                      onChequearSalida(salida, false);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <ClearIcon />
                  </DangerIconContainer>
                </div>
              )}
              {!transportado && salida.ingreso && (
                <div className="col-3">
                  <SuccessIconContainer
                    onClick={() => {
                      onChequearSalida(salida, true);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <CheckIcon />
                  </SuccessIconContainer>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <small>{salida.hora}</small>
        </div>
        <div className="row">
          <small>
            {salida.direccion} - {salida.sector}
          </small>
        </div>
      </div>
    </ListGroupItem>
  );
}

export default SalidaItem;
